import {PageTransformFn} from '../types'
import {ServerPageData} from '@/src/core/domain/entities/page/page-data'
import {BasketPageContent} from '@/src/entities/basket'
import keys from 'lodash/keys'

export const cartTransform: PageTransformFn = async (data: ServerPageData<BasketPageContent>) => {
  if (!data.meta) {
    data.meta = {}
  }

  if (keys(data.content.cart.lines).length == 0) {
    data.meta['empty-cart'] = 'Digi Empty Cart Page'
  } else {
    data.meta['cart'] = 'Digi Cart Page'
  }

  return data
}
